import React, { useEffect, useState } from 'react'
import { Tabs } from 'components'
import TabPanel from 'components/TabPanel'
import { addKeyToObjectsArray } from 'utils/addUniqueKeyToObjects'

import ComplianceListConfig from 'components/OptionsConfig/ComplianceListConfig'

import history from 'utils/history'
import { useSelector } from "react-redux"
import jwtDecode from "jwt-decode"
import { readOptionsManagementScopes } from "utils/authUtils"
import EmployeesConfig from 'components/OptionsConfig/EmployeesConfig/index.jsx'
import CnaesConfig from 'components/OptionsConfig/CnaesConfig/index.jsx'
import styles from './styles'
import JobRoleConfig from "../../components/OptionsConfig/JobRoleConfig"
import OccupationAreaConfig from "../../components/OptionsConfig/OccupationAreaConfig"
import { ROUTE_CONSTANTS } from "../../utils/constants/routeConstants"

const ConfigOptions = () => {
  const classes = styles()
  const token = useSelector((state) => state.auth.access_token)
  
  const [activeTab, setActiveTab] = useState(0)

  const tabs = addKeyToObjectsArray([
    { label: 'Cargos' },
    { label: 'Áreas de ocupação' },
    { label: 'Compliance List' },
    { label: 'Colaboradores' },
    { label: 'Cnaes' },
  ])

  useEffect(() => {
    const decoded = jwtDecode(token)
    if (!readOptionsManagementScopes.every(scope => decoded.scopes.includes(scope))) {
      history.push(ROUTE_CONSTANTS.HOME)
      history.go(0)
    }
  }, [token])
  
  return (
    <div className={classes.root}>
      <div className={classes.textContent}>
        <h2>Configurações de restrições e buscas</h2>
        <p>
          Nesta tela é possível visualizar, buscar e adicionar restrições e
          opções de busca das categorias exibidas abaixo. Para mudar de
          categoria basta clicar no nome da mesma.
        </p>
      </div>
      <div className={classes.tabWrapper}>
        <Tabs
          initialValue={0}
          tabs={tabs}
          onChange={(value) => setActiveTab(value)}
        ></Tabs>
        <TabPanel value={activeTab} index={0} className={classes.panel}>
          <JobRoleConfig />
        </TabPanel>     
        <TabPanel value={activeTab} index={1} className={classes.panel}>
          <OccupationAreaConfig />
        </TabPanel> 
        <TabPanel value={activeTab} index={2} className={classes.panel}>
          <ComplianceListConfig />
        </TabPanel>
        <TabPanel value={activeTab} index={3} className={classes.panel}>
          <EmployeesConfig />
        </TabPanel>
        <TabPanel value={activeTab} index={4} className={classes.panel}>
          <CnaesConfig />
        </TabPanel>
      </div>
    </div>
  )
}

ConfigOptions.propTypes = {}

export default ConfigOptions
